var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 8 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"4","cy":"4.29889","r":"4","fill":"#7B7E8C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }